import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { c as clsx } from "../../../chunks/clsx-DgYk2OaC.js";
import { Icon } from "../../../foundations/icons/Icon.js";
import { Text } from "../../../foundations/typography/Text/Text.js";
import { Checkbox } from "../../input/foundations/Checkbox/Checkbox.js";
import { useCheckboxGroupProvider } from "../../input/foundations/Checkbox/hooks/useCheckboxContext.js";
import { s as styles } from "../../../chunks/Badge.module-DY1hgB_U.js";
const BadgeCheckbox = forwardRef(
  ({ children, value, className, ...props }, ref) => {
    const { state } = useCheckboxGroupProvider();
    const isSelected = state.isSelected(value);
    return /* @__PURE__ */ jsx(
      Checkbox,
      {
        ref,
        value,
        className: clsx(styles.badge, styles.badgeCheckbox, className),
        selectedClassName: clsx(styles.badgeIsSelected, styles.badgeIsDismissible),
        pressedClassName: styles.badgeIsPressed,
        focusedClassName: styles.badgeIsFocused,
        ...props,
        children: /* @__PURE__ */ jsxs(Text, { variant: "text-body-head", component: "span", className: styles.badgeText, children: [
          children,
          isSelected ? /* @__PURE__ */ jsx(Icon, { variant: "XSmall", "aria-hidden": true }) : null
        ] })
      }
    );
  }
);
export {
  BadgeCheckbox
};
